import styled from "styled-components"
import { Icon } from "app/components/Icon"

export const StyledOptionIcon = styled(Icon)`
  margin-left: ${({ theme }) => theme.space[0]};
`
